import moment from "moment";
import { useEffect, useState } from "react";
import Select from "../components/UI/Select";
import { Spinner } from "../components/UI/Spinner";
import SearchBar from "../components/UI/SearchBar";
import { methodGet } from "../providers/ApiProvider";
import Structure from "../components/navigation/Structure";
import BonDeLocationTable from "../components/dashboard/BonDeLocationsTable";

let agencies = null;

export default function History() {
  const [bons, setBons] = useState(null);
  const [bonsFiltered, setBonsFiltered] = useState(null);
  const [search, setSearch] = useState("");
  const [agencyOptions, setAgencyOptions] = useState(agencies);
  const [agencySelected, setAgencySelected] = useState(null);
  const [dates, setDates] = useState([moment().subtract(6, "months").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      methodGet(
        "/bonlocationapi/rentalagreements/all" +
          (dates[0] !== "" ? `?dateFrom=${moment(dates[0]).format("YYYY-MM-DD")}` : "") +
          (dates[1] !== "" ? `&dateTo=${moment(dates[1]).format("YYYY-MM-DD")}` : "")
      )
        .then((res) => {
          res = res.filter((e) => e.status_id >= 6);
          setBons(res);
        })
        .catch((err) => {
          if (err.error.code === 404) setBons([]);
        });
    }, 1000);

    return () => {
      clearTimeout(timeout);
      setBons(null);
      setBonsFiltered(null);
    };
  }, [dates]);

  useEffect(() => {
    if (!agencyOptions)
      methodGet("/bonlocationapi/agency").then((res) => {
        setAgencyOptions(res);
        agencies = res;
      });
  }, [agencyOptions]);

  useEffect(() => {
    if (bons === null) return;
    let filtered = bons.filter(
      (e) =>
        (e.societe.nom && e.societe.nom.toLowerCase().includes(search.toLowerCase())) ||
        (e.ref && e.ref.toLowerCase().includes(search.toLowerCase())) ||
        (e.ref_order && e.ref_order.toLowerCase().includes(search.toLowerCase())) ||
        (e.applicant && e.applicant.toLowerCase().includes(search.toLowerCase())) ||
        (e.agency.name && e.agency.name.toLowerCase().includes(search.toLowerCase())) ||
        (e.name_agent && e.name_agent.toLowerCase().includes(search.toLowerCase()))
    );

    if (agencySelected !== null) filtered = filtered.filter((e) => e.agency.id === agencySelected.value);

    setBonsFiltered(filtered);
  }, [bons, search, agencySelected]);

  return (
    <Structure
      title={"Historique"}
      headerElements={() => (
        <>
          <div className="flex space-x-2 items-center mr-auto">
            <p className="text-sm">Du : </p>
            <input
              type="date"
              className=" bg-gray-50 dark:bg-gray-900 rounded-xl text-sm"
              value={dates[0]}
              onChange={(e) => setDates([e.target.value, dates[1]])}
            />
            <p className="text-sm">Au : </p>
            <input
              type="date"
              className=" bg-gray-50 dark:bg-gray-900 rounded-xl text-sm"
              value={dates[1]}
              onChange={(e) => setDates([dates[0], e.target.value])}
            />
          </div>
          {agencyOptions && (
            <Select
              options={[
                ...agencyOptions.map((e) => {
                  return { value: e.id, label: e.name };
                }),
              ]}
              placeholder={"Agence . . ."}
              onChange={(e) => setAgencySelected(e)}
            />
          )}
          <SearchBar id="search_dashboard" placeholder="Rechercher . . ." onChange={(value) => setSearch(value)} />
        </>
      )}
    >
      <div className="mt-10">
        {!bonsFiltered && <Spinner />}
        {bonsFiltered && <BonDeLocationTable bons={bonsFiltered} search={search} />}
      </div>
    </Structure>
  );
}
